import { decode } from 'js-base64';
import React from 'react';
import { useSelector } from 'react-redux';
import { selectPageModelCategoryText } from 'store/pageModel';
import { pageStyles } from './styles';

export const KzInstore = () => {
	const categoryText = useSelector(selectPageModelCategoryText);
	return (
		<div
			className={pageStyles}
			data-qa="kz-instore"
			dangerouslySetInnerHTML={{ __html: decode(categoryText || '') }}
		></div>
	);
};
